var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#010202","d":"M180.3865,341.446L45.0966,206.1561L0,251.2527l180.3865,180.3866L566.9291,45.0966L521.8325,0L180.3865,341.446z"}));
}

Tick.defaultProps = {"focusable":"false","viewBox":"0 0 566.9291 431.6392"};

module.exports = Tick;

Tick.default = Tick;
